import { render, staticRenderFns } from "./LoaderCard.vue?vue&type=template&id=19e16632&scoped=true"
import script from "@/components/loader-card/LoaderCard.ts?vue&type=script&lang=ts&external"
export * from "@/components/loader-card/LoaderCard.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/loader-card/loader-card.scss?vue&type=style&index=0&id=19e16632&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e16632",
  null
  
)

export default component.exports